var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","align-center":""}},[_c('div',{staticClass:"display-2 grey--text main-title"},[_vm._v(_vm._s(_vm.$t('page_not_found')))]),_vm._v(" "),_c('div',{staticClass:"body-2 my-3"},[_c('router-link',{attrs:{"to":{ name: _vm.home }}},[_vm._v("\n      "+_vm._s(_vm.$t('go_home'))+"\n    ")])],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b97735","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/errors/404.vue
// module id = V6cV
// module chunks = 0